import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, loading, initializing } = useAuth();
  const location = useLocation();

  // Show loading state while initializing OR during API calls
  if (initializing || loading) {
    return (
      <div className="loading-container">
        <div className="spinner"></div>
      </div>
    );
  }

  // Check authentication
  if (!isAuthenticated) {
    // Save the current location for redirect after login
    return <Navigate to="/" state={{ from: location.pathname }} replace />;
  }

  // Render the protected component if authenticated
  return children;
};

export default ProtectedRoute;